// apps/mediahaven2/src/bootstrap/services/app-initializer.service.ts
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentConfigService, RouterStateResolverService } from '@stylehaven/components';
import { SharedLanguageService } from '@language';
import { MessageFormatLoaderService } from './message-format-loader';

@Injectable({ providedIn: 'root' })
export abstract class AbstractBootstrapService {
    private readonly translateService: SharedLanguageService = inject(SharedLanguageService);
    private readonly routerStateResolver: RouterStateResolverService = inject(RouterStateResolverService);
    private readonly messageFormatLoader: MessageFormatLoaderService = inject(MessageFormatLoaderService);
    protected abstract readonly config: EnvironmentConfigService;

    /**
     * Initialize the application
     * Runs all required initialization tasks in sequence
     */
    public abstract initializeApp(): Promise<void>;

    protected initializeTranslations(): Observable<void> {
        return this.config.getConfig().pipe(
            map(config => {
                this.translateService.init(config.fallbackLanguage);
            })
        );
    }

    protected initializeRouterState(): Observable<boolean> {
        return of(true);
    }

    protected initializeMessageFormat(): Promise<void> {
        return this.messageFormatLoader.loadMessageFormatCompiler();
    }
}
